export default __webpack_public_path__ + "static/cta-image-7281d0965ffd91ac4fcb528af08757b4.svg";